import BackgroundLines from "./components/BackgroundLines/BackgroundLines";
import Main from "./components/Main/Main";


function App() {
 


  return (
    <div>
      <BackgroundLines />
      <Main />
    </div>
  );
}

export default App;
